<template>

  <v-container class="pr-0 user-account-controls d-flex align-center justify-end" v-if="isUserLoggedIn">

    <!-- User name -->
    <div @click="openMenu" v-if="!hideDisplayName">
      {{ activeUser.display_name }}
    </div>

    <!-- User avatar -->
    <v-avatar class="ml-3 user-avatar" @click="openMenu" v-if="showAvatar">
      <img :src="userAvatarImage">
    </v-avatar>

    <!-- Account controls menu -->
    <v-menu offset-y class="account-controls-menu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon class="ml-1 account-controls-btn" v-bind="attrs" v-on="on">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list class="account-controls-menu-list">
        <v-list-item class="account-controls-menu-list-item">
          <v-btn plain @click="$root.goTo('user-settings-profile')">User Settings</v-btn>
        </v-list-item>
        <v-list-item class="list-item-logout">
          <v-btn plain @click="$root.logout">Logout</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>

  </v-container>

</template>

<script>
export default {
  name: 'UserAccountControls',

  data () {
    return {
      showAvatar: false,
      avatarImage: null,
      isMenuOpen: false
    }
  },

  computed: {
    logoutText () {
      return 'Logout'
    },
    activeUser () {
      return this.$store.getters['auth/activeUser']
    },
    isMobileView () {
      return (window && window.innerWidth && window.innerWidth < 600)
    },
    hideDisplayName () {
      // Hide the display name if nav is open on mobile view
      return this.isMobileView && this.$root.isMainNavOpen()
    },
    isMainNavOpen () {
      return this.$root.isMainNavOpen()
    },
    userAvatarImage () {
      return this.avatarImage || this.activeUser.avatar_thumb_url
    },
    isUserLoggedIn () {
      return this.activeUser.is_logged_in
    },
    activeUserRoles () {
      return this.activeUser.roles
    },
    isAwaitingAccountApproval () {
      return this.activeUserRoles && this.activeUserRoles.length === 0
    }
  },

  beforeMount () {
    if (this.showAvatar) this.loadAvatarImage()
  },

  methods: {
    hasRole (role) {
      return this.$root.utils.includes(this.activeUserRoles, role)
    },

    async loadAvatarImage () {
      const avatarImage = await this.$root.fetchUserAsset('avatar_image')
      this.avatarImage = avatarImage
    },

    openMenu () {
      this.isMenuOpen = true
    }
  }
}
</script>

<style>
  .account-controls-menu-list {
    margin-top: 6px;
    margin-right: 10px;
    padding: 6px 0 12px 0 !important;
  }

  .account-controls-menu-list-item {
    margin-top: 6px !important;
    cursor: pointer;
  }

  .list-item-logout {
    margin-top: 8px !important;
  }

  @media (max-device-width:600px) {
    .user-account-controls {
      padding-top: 10px;
    }
    .user-avatar {
      display: none;
    }
    .account-controls-menu {
      display: none;
    }
    .account-controls-btn {
      display: none;
    }
  }
</style>
